import { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../shared/styles/globals.css";

import { AuthProvider, ThemeProvider } from "./providers";
import { PrivateRoute } from "./router";
import { Spinner } from "../shared/components/ui";

// ── Feature route definitions ──────────────────────────────
import { publicRoutes, authRoutes as welcomeRoutes } from "../features/welcome/routes";
import { authRoutes as authPageRoutes } from "../features/auth/routes";
import { adminRoutes } from "../features/admin/routes";
import { formateurRoutes } from "../features/formateur/routes";
import { apprenantRoutes } from "../features/apprenant/routes";

const fallback = (
  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
    <Spinner size={40} />
  </div>
);

const renderRoutes = (routes) =>
  routes.map((r) => <Route key={r.path} path={r.path} element={r.element} />);

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <Suspense fallback={fallback}>
            <Routes>
              {renderRoutes(publicRoutes)}
              {renderRoutes(authPageRoutes)}
              {renderRoutes(welcomeRoutes.map((r) => ({ ...r, element: <PrivateRoute>{r.element}</PrivateRoute> })))}
              {renderRoutes(adminRoutes.map((r) => ({ ...r, element: <PrivateRoute>{r.element}</PrivateRoute> })))}
              {renderRoutes(formateurRoutes.map((r) => ({ ...r, element: <PrivateRoute>{r.element}</PrivateRoute> })))}
              {renderRoutes(apprenantRoutes.map((r) => ({ ...r, element: <PrivateRoute>{r.element}</PrivateRoute> })))}
            </Routes>
          </Suspense>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
